import React from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import GeneralTab from './Tabs/GeneralTab';
import ConditionsTab from './Tabs/ConditionsTab';
import { RULE_TYPES } from '../shared/constants/app_constants';

import ValueSettingExpressionRouter from './ValueSettingExpressionRouter';
import ValidatingRuleSection from './ValidatingRuleSection';
import FilteringRuleSection from './FilteringRuleSection';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';

const modelName = "form_rule";

export default class FormRuleEditor extends React.Component{
  constructor(props){
    super(props);
    let form_rule = props.form_rule;
    let form_rule_state = {
      ...props.form_rule,
      id: form_rule.id || undefined,
      name: form_rule.name || "",
      rule_condition: form_rule.rule_condition || "",     //TODO: not in use anymore
      rule_expression: form_rule.rule_expression || "",   //TODO: not directly edited anymore
      target_attribute_ids: form_rule.target_attribute_ids || [],
      source_attribute_ids: form_rule.source_attribute_ids || [],
      show_expression_editor: false,                      //TODO: might be deletable
      expression_editor_value: undefined,                 //TODO: might be deletable
      expression_editor_attribute_name: undefined,        //TODO: might be deletable
      //this is specific for logic related to conditions
      nocode_condition_joiner: form_rule.nocode_condition_joiner || "AND",
      use_nocode_condition: form_rule.use_nocode_condition || false,
      form_rule_conditionals: [],
    };

    //TODO: deprecated, is being replaced by conditionals
    //if this has an id and metadata, populate use_nocode_condition
    if (props.form_rule && props.form_rule.id && props.form_rule.metadata){
      let condition_expressions = [];
      if ( props.form_rule.metadata && props.form_rule.metadata.condition_expressions){
        for (let [index, condition] of Object.entries(props.form_rule.metadata.condition_expressions)) {
          condition_expressions.push({
            ...condition,
            index: parseInt(index)
          })
        }
      }
      form_rule_state.condition_expressions = condition_expressions;
    }

    if (props.form_rule && props.form_rule.id && props.form_rule.form_rule_conditionals){
      let form_rule_conditionals = [];
      for (let [index, conditional] of Object.entries(props.form_rule.form_rule_conditionals)) {
        console.log('initialize conditional: ', conditional);
        let formRuleConditional = {
          ...conditional,
          index: parseInt(index),
          _destroy: false
        };

        // TODO: parse operand2_hash to create correct objects
        if (!!conditional.operand2_hash){
          const operand2_hash = conditional.operand2_hash;
          if (!!operand2_hash.operand2_fa_uuid){
            formRuleConditional.operand2_fa_uuid = operand2_hash.operand2_fa_uuid;
          }
          if (!!operand2_hash.operand2_value){
            formRuleConditional.operand2_value = operand2_hash.operand2_value
          }
          if (!!operand2_hash.operand2_options){
            formRuleConditional.operand2_options = operand2_hash.operand2_options;
          }
        }

        form_rule_conditionals.push(formRuleConditional);
      }
      form_rule_state.form_rule_conditionals = form_rule_conditionals;
    }

    if (props.form_rule.rule_type == RULE_TYPES.VALIDATING){
      form_rule_state.message_content = props.form_rule.message_content || "";
      if (!props.form_rule.id && !props.form_rule.form_rule_conditionals){
        //TODO: should we validate that this has no current condition_expressions?
        const newConditional = this.getNewConditionExpression();
        newConditional.index = 0;
        form_rule_state.form_rule_conditionals = [newConditional];
      }
    }

    if (props.form_rule.rule_type == RULE_TYPES.FILTERING) {
      let filteringConditionalsArr = props.form_rule.filtering_conditionals;
      if (filteringConditionalsArr.length === 0) {
        const newCondition = this.getNewConditionExpression();
        filteringConditionalsArr = [newCondition]; 
      }
      form_rule_state.filtered_options = props.form_rule.filtered_options || [];
      form_rule_state.filtering_conditionals = filteringConditionalsArr;
      form_rule_state.dynamic_filtering = props.form_rule.dynamic_filtering || false;
      form_rule_state.dynamic_filtering_joiner = props.form_rule.dynamic_filtering_joiner || "AND";
    }
    
    this.state = {
      form_rule: form_rule_state,
      activeTab: "general",
      showGuide: (props.form_rule.id )
    }
  }

  addNewCondition = () => {
    let formRuleState = {...this.state.form_rule};
    let newConditional = this.getNewConditionExpression();
    newConditional.index = formRuleState.form_rule_conditionals.length;
    formRuleState.form_rule_conditionals = formRuleState.form_rule_conditionals.concat(newConditional);
    this.setState({
      form_rule: formRuleState
    });
  }

  addNewFilteringCondition = () => {
    let formRuleState = {...this.state.form_rule};
    let newConditional = this.getNewConditionExpression();
    newConditional.index = formRuleState.filtering_conditionals.length;
    formRuleState.filtering_conditionals = formRuleState.filtering_conditionals.concat(newConditional);
    this.setState({
      form_rule: formRuleState
    });
  }

  // TODO: this requires more validations
  allConditionsAreValid = (conditionals_array) => {
    let allConditionsAreValid = true;
    // const formRuleConditionals = this.state.form_rule.form_rule_conditionals;
    conditionals_array.forEach(conditional => {
      if (conditional.operand1_uuid === undefined 
        || conditional.operand1_value_type === undefined
        || conditional.operator === undefined){
        allConditionsAreValid = false;
      } // TODO: check if operator needs operand 2
    });
    return allConditionsAreValid;
  }

  // if this has an id the mart _destroy to TRUE, else just remove this from array
  deleteCondition = (index) => {
    let formRuleState = {...this.state.form_rule};
    const thisConditional = formRuleState.form_rule_conditionals[index];
    if (!!thisConditional.id){
      formRuleState.form_rule_conditionals[index]._destroy = true;
    } else {
      formRuleState.form_rule_conditionals.splice(index, 1);
    }
    this.setState({
      form_rule: formRuleState
    });
  }

  deleteFilteringConditional = (index) => {
    let formRuleState = {...this.state.form_rule};
    const thisFilteringConditional = formRuleState.filtering_conditionals[index];
    if (!!thisFilteringConditional.id){
      formRuleState.filtering_conditionals[index]._destroy = true;
    } else {
      formRuleState.filtering_conditionals.splice(index, 1);
    }
    this.setState({
      filtering_conditional: formRuleState
    });
  }

  formRuleIsValid () {
    const targetSubmitButton = this.props.form_rule.metadata?.target_submit_button;
    let formRuleIsValid = true;
    const form_rule = this.state.form_rule;
    // validate that form rule has target attributes
    if (form_rule.target_attribute_ids.length < 1 && targetSubmitButton !== true){
      formRuleIsValid = false;
    }
    //validate that form rule name exists
    if (form_rule.name.trim().length === 0 || form_rule.name.trim().length > 100 ){
      formRuleIsValid = false;
    }
    //rule type is required
    if (!form_rule.rule_type){
      formRuleIsValid = false;
    }

    if (form_rule.use_nocode_condition === true) {
      if (form_rule.use_condition_function !== true) {
        const conditionsAreValid = this.allConditionsAreValid(form_rule.form_rule_conditionals);
        if (conditionsAreValid  === false) {
          formRuleIsValid = false
        }
      } else {
        // TODO: validate condition function
        console.log('validate condition function as well as type function');
      }
    }

    if (form_rule.rule_type === RULE_TYPES.FILTERING) {
      if (form_rule.dynamic_filtering === true) {
        let allConditionsAreValid = true;
        form_rule.filtering_conditionals.forEach(conditional => {
          if (!conditional.operand1_uuid) {
            allConditionsAreValid = false;
          } else if (!conditional.operator) {
            allConditionsAreValid = false;
          }
          // TODO check this operator to make sure
          if (!conditional.operand2_pre_type){
            allConditionsAreValid = false;
          }
          // TODO: there are a lot of things this could be
          if (!conditional.operand2_pre_type !== "none") {
            // TODO: revisit this, as there is a lot more to validate
          }
        });
        if (!allConditionsAreValid){
          formRuleIsValid = false;
        }
      }
    }
    
    // validate that if use_nocode_condition === TRUE then each condition is valid
    // TODO: validate that if rule_type is value_setting then
    // return value matches format of value type (number, string or select value)
    // TODO: we don't know yet, validate that if rule_type is returning
    return formRuleIsValid;
  }

  // TODO: needs to be updated 
  getNewConditionExpression(){
    return {
      operand1_uuid: undefined,
      operand1_value_type: undefined,
      operator: undefined,
      operand2_pre_type: undefined,
      _destroy: false
    };
  }

  setUseConditionExpressionBlockFlag = (flagValue) => {
    let formRuleState = {
      ...this.state.form_rule,
      use_nocode_condition: flagValue
    };
    if (flagValue === true && this.state.form_rule.form_rule_conditionals.length === 0){
      // initialize condition
      const blankCondition = this.getNewConditionExpression();
      blankCondition.index = 0;
      formRuleState.form_rule_conditionals = [blankCondition];
    }
    this.setState({
      form_rule: formRuleState
    });
  }

  showSectionPerFormRuleType(){
    const targetAttributeID = this.state.form_rule.target_attribute_ids[0];
    const targetAttribute = this.props.keenform.form_attributes.find(fa => fa.id === targetAttributeID);
    switch(this.state.form_rule.rule_type){
      case RULE_TYPES.HIDING:
      case RULE_TYPES.LOCKING:
        //nothing special to show here
        return undefined;
      case RULE_TYPES.VALUE_SETTING:
        return <ValueSettingExpressionRouter
        keenform={this.props.keenform}
        form_rule={this.state.form_rule}
        current_user={this.props.current_user}
        updateAttributeOnEvent={this.updateFormRuleAttributeOnEvent} />;
      case RULE_TYPES.VALIDATING:
        return <ValidatingRuleSection
          keenform={this.props.keenform}
          form_rule={this.state.form_rule}
          updateAttributeOnEvent={this.updateFormRuleAttributeOnEvent} />;
      case RULE_TYPES.FILTERING:
        return <FilteringRuleSection
          keenform={this.props.keenform}        
          form_rule={this.state.form_rule}
          target_attribute={targetAttribute}
          addNewCondition={this.addNewFilteringCondition}
          allConditionsAreValid={this.allConditionsAreValid(this.state.form_rule.filtering_conditionals)}
          updateAttributePerParams={this.updateFormRuleAttributePerParams}
          updateFormRuleAttributePerParams={this.updateFormRuleAttributePerParams}
          deleteFilteringConditional={this.deleteFilteringConditional}
          updateAttributeOnEvent={this.updateFormRuleAttributeOnEvent} />;
      default:
        console.error('invalid rule type');
        return undefined;
    }
  }

  toggleDisableRule(checked){
    this.setState({
      form_rule: {
        ...this.state.form_rule,
        disable_rule: checked
      }
    });
  }

  toggleTargetAttribute(targetAttributeId){
    let targetAttributeIds = [...this.state.form_rule.target_attribute_ids];
    switch (this.state.form_rule.rule_type){
      case "hiding":
      case "locking":
        if (targetAttributeIds.includes(targetAttributeId)){
          targetAttributeIds = targetAttributeIds.filter(faid => faid !== targetAttributeId);
        }else{
          targetAttributeIds.push(targetAttributeId);
        }
        break;
      default:
        targetAttributeIds = [targetAttributeId];
    }

    this.setState({
      form_rule: {
        ...this.state.form_rule,
        target_attribute_ids: targetAttributeIds
      }
    });
  }

  /**
   * update form rule attribute using event
   * name of form rule attribute must match state attribute name
   */
  updateFormRuleAttributeOnEvent = (event) => {
    let targetName = event.target.name;
    let attributeNameMatches = /\[(.*)\]/.exec(targetName);
    if (attributeNameMatches && attributeNameMatches.length === 2){//TODO: should we use text match?
      const attributeName = attributeNameMatches[1];
      let formRuleState = {...this.state.form_rule};
      formRuleState[attributeName] = event.target.value;
      this.setState({
        form_rule: formRuleState
      });
    }
  }

  //pass 2 params, form rule attribute and new value, function will update
  updateFormRuleAttributePerParams = (attributeName, attributeValue) => {
    let formRuleState = {...this.state.form_rule};
    formRuleState[attributeName] = attributeValue;
    this.setState({
      form_rule: formRuleState
    });
  }

  render(){
    return (
      <React.Fragment>
        <BootstrapSwitchButton 
          onlabel='Disabled' 
          offlabel='Enabled'
          onstyle='danger'
          offstyle='success'
          width='200'
          size="lg"
          onChange={(checked) => {
            this.toggleDisableRule(checked);
          }}
          checked={ this.state.form_rule.disable_rule } />
        <input 
          type="hidden" 
          name="form_rule[disable_rule]" 
          value={( this.state.form_rule.disable_rule === true ? 1 : 0 )} />
        <Tabs 
          activeKey={this.state.activeTab}
          onSelect={ key => this.setState({activeTab: key}) }
          id="form-rule-editor">
        <Tab eventKey="general" title="General">
          <GeneralTab
            updateFormRuleAttributePerParams={this.updateFormRuleAttributePerParams}
            updateAttributeOnEvent={this.updateFormRuleAttributeOnEvent}
            toggleTargetAttribute={this.toggleTargetAttribute.bind(this)}
            form_rule={this.state.form_rule}
            form_rule_types={this.props.form_rule_types}
            keenform={this.props.keenform}
            modelName={modelName} />
          { this.showSectionPerFormRuleType() }
        </Tab>
        <Tab eventKey="condition" title="Conditions">
          <ConditionsTab
            form_rule={this.state.form_rule}
            keenform={this.props.keenform}
            allConditionsAreValid={this.allConditionsAreValid(this.state.form_rule.form_rule_conditionals)}
            updateFormRuleAttributePerParams={this.updateFormRuleAttributePerParams}
            updateAttributeOnEvent={this.updateFormRuleAttributeOnEvent}
            setUseConditionExpressionBlockFlag={this.setUseConditionExpressionBlockFlag}
            addNewCondition={this.addNewCondition}
            deleteCondition={this.deleteCondition} />
        </Tab>
      </Tabs>
      <div className="row">
        <div className="col-6" />
        <div className="col-6 text-right">
          <button 
            className="btn btn-primary"
            disabled={!this.formRuleIsValid()}
            type="submit">
            <i className="fa fa-save"></i> SAVE
          </button>
        </div>
      </div>
    </React.Fragment>);
  }
}
